import { useFlags as useFlagsBase } from '@phx/feature-flags/client';

import type { FlagSet } from '../generated/feature-flags';

// This is just a helpful wrapper so we don't need to remember to import and use `FlagSet` everywhere we call `useFlags` from the feature-flags package
export const useFlags = () => useFlagsBase<FlagSet>();
